<div class="card p-3 pb-5 mb-5 d-flex flex-column gap-3 mt-2">
  <nz-skeleton
    [nzLoading]="loading"
    [nzActive]="true"
    class="d-flex flex-column"
  >
    <div class="d-flex align-items-center gap-3">
      <img
        src="https://storage.googleapis.com/komerce/assets/icons/back.svg"
        alt="back"
        class="cursor-pointer"
        (click)="back()"
      />
      <div class="title">User Acceptance Testing</div>
    </div>
    <div class="mt-4 py-3 px-4" style="background-color: #f8f8f8">
      <nz-steps
        [nzCurrent]="current"
        [nzDirection]="isMediumScreen ? 'vertical' : 'horizontal'"
        [nzStartIndex]="0"
        nzSize="small"
        class="d-flex flex-column flex-xl-row"
      >
        <ng-container *ngFor="let step of stepList; let i = index">
          <nz-step
            (click)="handleStep(i + 1)"
            [nzTitle]="step"
            style="cursor: pointer"
          ></nz-step>
        </ng-container>
      </nz-steps>
    </div>
    <app-uat-payment-method *ngIf="current === 0" [uatPaymentMethod]="paymentMethod" [uatData]="uatData"></app-uat-payment-method>
    <app-uat-create-va *ngIf="current === 1" [uatPaymentMethod]="createVa" [uatData]="uatData"></app-uat-create-va>
    <app-uat-create-qris *ngIf="current === 2" [uatPaymentMethod]="createQris" [uatData]="uatData"></app-uat-create-qris>
    <app-uat-status-payment (submitUATFinal)="updateState()" *ngIf="current === 3" [uatPaymentMethod]="statusPayment" [uatData]="uatData"></app-uat-status-payment>
    <!-- <app-uat-cancel-payment (submitUATFinal)="updateState()" *ngIf="current === 4" [uatPaymentMethod]="cancelPayment" [uatData]="uatData"></app-uat-cancel-payment> -->
  </nz-skeleton>
</div>
<app-modal-confirm-back
  [isShowConfirm]="isConfirmBack"
  [docType]="'UAT'"
  (isShowConfirmEvent)="closeConfirmBack()"
></app-modal-confirm-back>
